export default "__VITE_ASSET__a04b4ce4__"